export default __webpack_public_path__ + "static/media/CNo.59-2.862b2f39.jpg";